import { z } from 'zod';
import { ChatWebhookStatus } from './coach.js';
import { Email, IsoDate } from './common.js';
import { Preferences } from './notifications.js';
import { User } from './users.js';

/**
 * `GET /api/me` : l'utilisateur connecté, son rôle et ses préférences (schéma `Preferences`,
 * ajouté au contrat par le lot R avec l'accord du PM ; `{}` vaut « valeurs par défaut »).
 */
export const Me = User.extend({
  preferences: Preferences.prefault({}),
  /** Lot BF : webhook Google Chat du membre, jamais l'adresse (`users.chatWebhookEnc`). */
  chatWebhook: ChatWebhookStatus.default({ configured: false }),
});
export type Me = z.infer<typeof Me>;

/** `POST /api/auth/dev-login` (développement et tests seulement). */
export const DevLoginBody = z.object({ email: Email });
export type DevLoginBody = z.input<typeof DevLoginBody>;

/**
 * `GET /api/auth/config` (public, hors §3.7) : ce que l'écran de connexion doit proposer,
 * et la date du jour du serveur (figée par FAKE_TODAY en mode démo).
 */
export const AuthConfig = z.object({
  googleEnabled: z.boolean(),
  devLoginEnabled: z.boolean(),
  today: IsoDate,
  /**
   * Version déployée, affichée en pied de page (Maxime, 13/10/2026 : savoir ce qui est en production) :
   * version du package, commit court (celui de `git log --oneline`) et date du commit, s'ils sont connus.
   */
  build: z
    .object({ version: z.string(), commit: z.string().nullable(), committedAt: z.string().nullable() })
    .optional(),
});
export type AuthConfig = z.infer<typeof AuthConfig>;
